var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"fill":"#f35325","d":"M0 0h10v10H0z"}}),_c('path',{attrs:{"fill":"#81bc06","d":"M11 0h10v10H11z"}}),_c('path',{attrs:{"fill":"#05a6f0","d":"M0 11h10v10H0z"}}),_c('path',{attrs:{"fill":"#ffba08","d":"M11 11h10v10H11z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }